import { z } from "zod";

export const RegisterFormSchema = z.object({
  name: z.string().min(1, { message: "Nome inválido" }),
  email: z
    .string()
    .optional()
    .refine(
      (value) =>
        !value || value === "" || z.string().email().safeParse(value).success,
      { message: "Email inválido" },
    ),
  password: z.string().min(1, { message: "Senha inválida" }),
  phone: z.string().regex(/^55\d{11}$/, {
    message: "WhatsApp inválido",
  }),
  user_intent: z.string().min(1, { message: "Perfil inválido" }),
});
